module.exports = __webpack_public_path__ + "static/media/nf.99af5a94.svg";